const getThreadLastActivityTimestamp = (threadMeta) => {
  const updatedAtTimestamp = new Date(threadMeta?.updatedAt || 0).getTime();
  const createdAtTimestamp = new Date(threadMeta?.createdAt || 0).getTime();

  return Math.max(Number.isFinite(updatedAtTimestamp) ? updatedAtTimestamp : 0, Number.isFinite(createdAtTimestamp) ? createdAtTimestamp : 0);
};

export default getThreadLastActivityTimestamp;
